import { useMemo } from 'react';

import { useConvertLoyaltyPoints, useGetCompPointsConversionDetails, useGetDynamicBalances } from 'server';

export const useWalletPublicAPI = () => {
    const convertLoyaltyPoints = useConvertLoyaltyPoints();
    const getCompPointsConversionDetails = useGetCompPointsConversionDetails();
    const getDynamicBalances = useGetDynamicBalances();

    return useMemo(() => ({
        /**
         * See [ims docs]{@link https://integration.playtech.com/apis/openapi/services/WalletService/operations/ConvertLoyaltyPoints.html}
         * @memberOf Playtech.API.wallet
         * @function
         * @returns {Promise<{Object}>}
         * @example
         * Playtech.API.wallet.convertLoyaltyPoints().then((data) => { ... });
         */
        convertLoyaltyPoints,
        /**
         * See [ims docs]{@link https://integration.playtech.com/apis/openapi/services/WalletService/operations/GetCompPointsConversionDetails.html}
         * @memberOf Playtech.API.wallet
         * @function
         * @returns {Promise<{Object}>}
         * @example
         * Playtech.API.wallet.getCompPointsConversionDetails().then((data) => { ... });
         */
        getCompPointsConversionDetails,
        /**
         * See [ims docs]{@link https://integration.playtech.com/apis/openapi/services/WalletService/operations/GetDynamicBalances.html}
         * @memberOf Playtech.API.wallet
         * @function
         * @param {Object} options
         * @param {string[]} options.balanceTypes
         * @param {string} [options.clientType]
         * @param {string} [options.clientPlatform]
         * @param {string} [options.languageCode]
         * @returns {Promise<{Object}>} {balances: {balanceType: string, balance: {amount: string, currencyCode: string}}[]}
         * @example
         * Playtech.API.wallet.getDynamicBalances({ balanceTypes: ['real_gaming_balance'] }).then((data) => { ... });
         */
        getDynamicBalances
    }), [
        convertLoyaltyPoints,
        getCompPointsConversionDetails,
        getDynamicBalances
    ]);
};
